"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoading = setLoading;
exports.getUsersBet = exports.getLeaderboard = exports.getMyBet = exports.setLeaderboard = exports.GET_CURRENT_SCORE = exports.SET_FILTER_BY_ME = exports.GET_FILTERED_LEADERBOARD = exports.SET_PICKEM_ID = exports.SET_PAGE_NUMBER = exports.SET_ERROR = exports.SET_HAS_MORE = exports.SET_LOADING = exports.CLEAR_LEADERBOARD = exports.GET_ACTIVE_BET = exports.SET_LEADERBOARD = exports.SELECT_PICKEM = exports.GET_ALL_PICKEMS = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _dist = require("@low6dev/react-utils/dist");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// import { GET_CONTEST, GET_PICKEMS_BETS } from "../contest/actions";
//import { mockLeaderboard } from "mocks/mockLeaderboard.js";
var GET_ALL_PICKEMS = "leaderboard:GET_ALL_PICKEMS";
exports.GET_ALL_PICKEMS = GET_ALL_PICKEMS;
var SELECT_PICKEM = "leaderboard:SELECT_PICKEM";
exports.SELECT_PICKEM = SELECT_PICKEM;
var SET_LEADERBOARD = "leaderboard:SET_LEADERBOARD";
exports.SET_LEADERBOARD = SET_LEADERBOARD;
var GET_ACTIVE_BET = "leaderboard:GET_ACTIVE_BET";
exports.GET_ACTIVE_BET = GET_ACTIVE_BET;
var CLEAR_LEADERBOARD = "leaderboard:CLEAR_LEADERBOARD";
exports.CLEAR_LEADERBOARD = CLEAR_LEADERBOARD;
var SET_LOADING = "leaderboard:SET_LOADING";
exports.SET_LOADING = SET_LOADING;
var SET_HAS_MORE = "leaderboard:SET_HAS_MORE";
exports.SET_HAS_MORE = SET_HAS_MORE;
var SET_ERROR = "leaderboard:SET_ERROR";
exports.SET_ERROR = SET_ERROR;
var SET_PAGE_NUMBER = "leaderboard:SET_PAGE_NUMBER";
exports.SET_PAGE_NUMBER = SET_PAGE_NUMBER;
var SET_PICKEM_ID = "leaderboard:SET_PICKEM_ID";
exports.SET_PICKEM_ID = SET_PICKEM_ID;
var GET_FILTERED_LEADERBOARD = "leaderboard:GET_FILTERED_LEADERBOARD";
exports.GET_FILTERED_LEADERBOARD = GET_FILTERED_LEADERBOARD;
var SET_FILTER_BY_ME = "leaderboard:SET_FILTER_BY_ME";
exports.SET_FILTER_BY_ME = SET_FILTER_BY_ME;
var GET_CURRENT_SCORE = "leaderboard:GET_CURRENT_SCORE";
exports.GET_CURRENT_SCORE = GET_CURRENT_SCORE;

var setLeaderboard = function setLeaderboard(leaderboard) {
  return {
    type: SET_LEADERBOARD,
    payload: leaderboard
  };
};

exports.setLeaderboard = setLeaderboard;

var getMyBet = function getMyBet(activeUserBet, isShowingMyBet) {
  return function (dispatch) {
    dispatch(setLeaderboard({
      activeUserBet: isShowingMyBet ? activeUserBet : undefined,
      isShowingMyBet: isShowingMyBet
    }));
  };
};

exports.getMyBet = getMyBet;

var getLeaderboard = function getLeaderboard(activePickem, activeBet, stopFilteringMyBet, clearFirst, betbar, setBetbar) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _betbar$table, result, _profileRes$data, _profileRes$data$data, _profileRes$data2, _profileRes$data2$dat, _tableRes$data, tableRes, profileRes, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (clearFirst) {
                console.log("OH NO WERE CLEARING HERE!!!");
              }

              setBetbar({
                table: undefined
              });
              dispatch(setLeaderboard({
                loading: true
              })); // dispatch(setLoading(true));

              _context.prev = 3;

              if (activePickem) {
                _context.next = 9;
                break;
              }

              dispatch({
                type: SET_LEADERBOARD,
                payload: {
                  isPickemEmpty: true,
                  loading: false,
                  canBet: false
                }
              });
              setBetbar({
                table: []
              });
              console.log("pickem is empty");
              return _context.abrupt("return");

            case 9:
              console.log("leaderboard activeBet", activeBet);

              if (activeBet) {
                _context.next = 14;
                break;
              }

              dispatch({
                type: SET_LEADERBOARD,
                payload: {
                  isLeaderboardEmpty: true,
                  loading: false,
                  canBet: !activeBet && activePickem.status === "APPROVED"
                }
              });
              setBetbar({
                table: []
              });
              return _context.abrupt("return");

            case 14:
              if (!stopFilteringMyBet) {
                _context.next = 19;
                break;
              }

              dispatch(setLeaderboard({
                isShowingMyBet: false
              }));
              dispatch({
                type: SET_LEADERBOARD,
                payload: {
                  activeUserBet: {}
                }
              });

              if (!(betbar !== null && betbar !== void 0 && (_betbar$table = betbar.table) !== null && _betbar$table !== void 0 && _betbar$table.length)) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return");

            case 19:
              result = {
                loading: false,
                // activeBet,
                canBet: !activeBet && activePickem.status === "APPROVED"
              };

              if (!((activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "COMPLETED" || (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "IN_PLAY")) {
                _context.next = 32;
                break;
              }

              _context.next = 23;
              return _axios.default.get("/pickems/".concat(activePickem === null || activePickem === void 0 ? void 0 : activePickem.id, "/cached-leaderboard"));

            case 23:
              tableRes = _context.sent;
              _context.next = 26;
              return _axios.default.get("/me");

            case 26:
              profileRes = _context.sent;
              console.log("profileRes", profileRes);
              dispatch(setLeaderboard(_objectSpread(_objectSpread({}, result), {}, {
                isLeaderboardEmpty: false,
                userName: profileRes === null || profileRes === void 0 ? void 0 : (_profileRes$data = profileRes.data) === null || _profileRes$data === void 0 ? void 0 : (_profileRes$data$data = _profileRes$data.data) === null || _profileRes$data$data === void 0 ? void 0 : _profileRes$data$data.username,
                userImage: profileRes === null || profileRes === void 0 ? void 0 : (_profileRes$data2 = profileRes.data) === null || _profileRes$data2 === void 0 ? void 0 : (_profileRes$data2$dat = _profileRes$data2.data) === null || _profileRes$data2$dat === void 0 ? void 0 : _profileRes$data2$dat.image
              })));
              setBetbar({
                table: tableRes === null || tableRes === void 0 ? void 0 : (_tableRes$data = tableRes.data) === null || _tableRes$data === void 0 ? void 0 : _tableRes$data.data
              });
              _context.next = 34;
              break;

            case 32:
              dispatch(setLeaderboard(_objectSpread({}, result)));
              setBetbar({
                table: []
              });

            case 34:
              _context.next = 40;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](3);
              response = _context.t0.response;
              (0, _dist.handleError)(response);

            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 36]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getLeaderboard = getLeaderboard;

var getUsersBet = function getUsersBet(betId) {
  return function (dispatch) {
    dispatch({
      type: SET_LEADERBOARD,
      payload: {
        activeUserBet: undefined
      }
    });

    if (betId) {
      _axios.default.get("/pickem-cached-bet/".concat(betId)).then(function (_ref3) {
        var data = _ref3.data;
        dispatch({
          type: SET_LEADERBOARD,
          payload: {
            activeUserBet: data
          }
        });
      }).catch(function (_ref4) {
        var response = _ref4.response;
        (0, _dist.handleError)(response);
      });
    }
  };
}; // export const getMyBet = (activeBet) => async (dispatch, getState) => {
//   dispatch({
//     type: SET_LEADERBOARD,
//     payload: {
//       activeUserBet: undefined,
//     },
//   });
//
//   if (activeBet) {
//     dispatch({
//       type: SET_LEADERBOARD,
//       payload: {
//         activeUserBet: activeBet,
//         isShowingMyBet: true,
//       },
//     });
//   }
// };


exports.getUsersBet = getUsersBet;

function setLoading(value) {
  return {
    type: SET_LOADING,
    payload: value
  };
}